/* eslint-disable */
import { AUTH_PERSIST_KEY } from '../../Constants/Auth/Auth.constants';
import { I18N_PERSIST_KEY } from '../../Constants/I18n/I18n.constants';
import { STORAGE_PERSIST_KEY } from '../../Constants/Storage/Storage.constants';
import AnalyticsGoogleTagManagerAdapter from '../../Services/Analytics/Adapter/GoogleTagManager/AnalyticsGoogleTagManager.adapter';
import AnalyticsService from '../../Services/Analytics/Analytics.service';
import AuthBoralSecurityAdapter from '../../Services/Auth/Adapter/BoralSecurity/BoralSecurity.adapter';
import AuthOktaAdapter from '../../Services/Auth/Adapter/Okta/AuthOkta.adapter';
import AuthService from '../../Services/Auth/Auth.service';
import DeliveryService from '../../Services/Delivery/Delivery.service';
import DocketService from '../../Services/Docket/Docket.service';
import EntityService from '../../Services/Entity/Entity.service';
import HereMapsService from '../../Services/HereMaps/HereMaps.service';
import HttpService from '../../Services/Http/Http.service';
import I18nService from '../../Services/I18n/I18n.service';
import NotificationService from '../../Services/Notification/Notification.service';
import OrderService from '../../Services/Order/Order.service';
import StorageMemoryAdapter from '../../Services/Storage/Adapter/Memory/StorageMemory.adapter';
import StorageService from '../../Services/Storage/Storage.service';
import UserService from '../../Services/User/User.service';
import envGet from '../../Support/Env/Get/EnvGet.support';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

const hereMapsApiKey = envGet({ key: `REACT_APP_BORAL_HERE_MAPS_API_KEY` });

// This prod flag is set for now as Okta only works in dev.
// This also serves as a very simple `feature flag` as Okta based
// login should not go to prod yet but is needed to be tested on
// non-prod environments to be able to capture any issues while
// still having new features added to the develop branch.
const FEATURE_TOGGLE_OKTA_SUPPORT = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_OKTA_SUPPORT` }) === `true`;

// Create all of the services to be used by this entry
const httpService = new HttpService();
const i18nService = new I18nService({
  storageService: new StorageService({
    key: I18N_PERSIST_KEY,
    storageAdapter: new StorageMemoryAdapter({ key: I18N_PERSIST_KEY, store: { [I18N_PERSIST_KEY]: i18nStore.get() } }),
  }),
});
const storageService = new StorageService({ key: STORAGE_PERSIST_KEY, storageAdapter: localStorage });
const analyticsService = new AnalyticsService({
  analyticsAdapter: new AnalyticsGoogleTagManagerAdapter({
    config: {
      gtmKey: envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_GTM_KEY` }),
    },
  }),
});
const authBoralSecurityAdapter = new AuthBoralSecurityAdapter({
  config: {
    authorizeUrl: envGet({ key: `REACT_APP_BORAL_SECURITY_AUTHORIZE_URL` }),
  },
  httpService,
  storageService: new StorageService({ key: AUTH_PERSIST_KEY, storageAdapter: localStorage }),
});
const authOktaAdapter = new AuthOktaAdapter({
  config: {
    clientId: envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_CLIENT_ID` }),
    issuer: envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_ISSUER` }),
    redirectUri: `${window.location.origin}${envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_REDIRECT_URI` })}`,
  },
  httpService,
  storageService: new StorageService({ key: AUTH_PERSIST_KEY, storageAdapter: localStorage }),
});
const authService = new AuthService({
  authAdapter: FEATURE_TOGGLE_OKTA_SUPPORT ? authOktaAdapter : authBoralSecurityAdapter,
});
const deliveryService = new DeliveryService({ authService, httpService });
const entityService = new EntityService();
const notificationService = new NotificationService({ authService, httpService });
const docketService = new DocketService({
  authService,
  httpService,
  storageService: new StorageService({ key: STORAGE_PERSIST_KEY, storageAdapter: localStorage }),
});
const orderService = new OrderService({ authService, httpService });
const userService = new UserService({ authService, httpService });

const platform = window.H && window.H.service ? new window.H.service.Platform({
  apikey: hereMapsApiKey,
}) : {};

const hereMapsService = new HereMapsService({ platform, authService, httpService });

/**
 * Bundle up all of the services to inject
 * @type {Services}
 */
const portalCustomerServices = {
  analyticsService,
  authService,
  deliveryService,
  docketService,
  entityService,
  httpService,
  i18nService,
  notificationService,
  orderService,
  storageService,
  userService,
  hereMapsService,
};

export default portalCustomerServices;
